import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Constants} from '../../_constants/constants';
import {Tab} from '../../_models/tab';
import {TabNoteDefinition} from '../../_models/tab-note-definition';
import {Order} from '../../_models/order';
import {UserOrganizationCreditSummary} from '../../_models/user-organization-credit-summary';
import {CompDefinition} from '../../_models/comp-definition';
import {Organization} from '../../_models/organization';
import {PickupLocation} from '../../_models/pickup-location';
import {PickupLocationMenu} from '../../_models/pickup-location-menu';
import {Membership} from '../../_models/membership';
import {CashSession} from '../../_models/cash-information/cash-session';
import {TabStatuses} from '../../_constants/tab-statuses';
import {OrderItem} from '../../_models/order-item';
import {OrderItemSummary} from '../../_models/order-item-summary';
import {OrganizationTerminal} from '../../_models/organization-terminal';

@Component({
    selector: 'bb-order-container',
    templateUrl: './order-container.component.html',
    styleUrls: ['./order-container.component.scss'],
})
export class OrderContainerComponent implements OnInit {
    @Input() editMode = false;
    @Input() tab: Tab;
    @Input() applyNotes: TabNoteDefinition[];
    @Input() order: Order;
    @Input() showTabInfo = false;
    @Input() activeCredit: UserOrganizationCreditSummary;
    @Input() availableTabComps: CompDefinition[];
    @Input() availableOrderComps: CompDefinition[];
    @Input() organization: Organization;
    @Input() pickupLocation: PickupLocation;
    @Input() pickupLocationMenu: PickupLocationMenu;
    @Input() activeMembership: Membership;
    @Input() terminalMode: boolean;
    @Input() cashSession: CashSession;
    @Input() availableTokens: number;
    @Input() isBirthday: boolean;
    @Input() noteDefinitions: TabNoteDefinition[];
    @Input() screenWidth: number;
    @Input() terminal: OrganizationTerminal;
    @Input() orderAdded: boolean;
    @Input() isModal = false;

    @Output() selectMember: EventEmitter<any> = new EventEmitter();
    @Output() removeMember: EventEmitter<any> = new EventEmitter();
    @Output() payNow: EventEmitter<any> = new EventEmitter();
    @Output() clearCart: EventEmitter<any> = new EventEmitter();
    @Output() removeTokens = new EventEmitter<OrderItem>();
    @Output() addTokens = new EventEmitter<OrderItem>();
    @Output() updateItem: EventEmitter<OrderItem> = new EventEmitter<OrderItem>();
    @Output() openItemSummary: EventEmitter<OrderItemSummary> = new EventEmitter<OrderItemSummary>();
    @Output() addToSummary: EventEmitter<OrderItemSummary> = new EventEmitter<OrderItemSummary>();
    @Output() removeFromSummary: EventEmitter<OrderItemSummary> = new EventEmitter<OrderItemSummary>();
    @Output() removeItemSummary: EventEmitter<OrderItemSummary> = new EventEmitter<OrderItemSummary>();
    @Output() notesChanged: EventEmitter<TabNoteDefinition[]> = new EventEmitter();
    @Output() renewMembership: EventEmitter<OrderItem> = new EventEmitter<OrderItem>();
    @Output() addCredit: EventEmitter<OrderItem> = new EventEmitter<OrderItem>();
    @Output() removeCredit = new EventEmitter<any>();
    @Output() removeTabCredit = new EventEmitter<any>();

    @ViewChild('orderContainer') orderContainer: ElementRef;

    tabStatuses = TabStatuses;
    Constants = Constants;

    constructor() {
    }

    ngOnInit() {
    }

    async payNowClicked(event, paymentType: string = null) {
        event.stopPropagation();
        this.payNow.emit(paymentType);
    }

    async startBlankTab() {
        this.payNow.emit('START_BLANK_TAB');
    }

    selectNoteDefinitions() {
        this.notesChanged.emit(this.noteDefinitions);
    }

    scrollToSummary(itemSummary: OrderItemSummary) {
        if (!!this.orderContainer && !!itemSummary) {
            setTimeout(() => {
                const element = document.getElementById(`item_summary_${itemSummary.key}`);
                if (!!element) {
                    element.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'nearest'});
                }
            }, 150);
        }
    }
}
